import React, { ReactElement } from 'react'

import Employee from '../../../model/employee'
import { EmployeeReducer } from '../../../reducers/employees'
import { FormComponentProps, withValidations } from '../../../utils/form-utils'
import { t } from '../../../utils/translation-utils'
import Button from '../../elements/button'
import Col from '../../elements/grid/col'
import Row from '../../elements/grid/row'
import LoadingOverlay from '../../widgets/LoadingOverlay'

type Props = {
  employee: Employee
  employees: EmployeeReducer
  onCancel?: () => void
}

function DeleteEmployeeForm(props: Props & FormComponentProps<any, any>): ReactElement | null {
  const { employee } = props
  const isFreelancer = employee.affiliationType === 'Freelancer'

  return (
    <div>
      {props.getFormError()}
      <Row>
        <Col span={24} style={{ textAlign: 'right', display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
          {props.onCancel && (
            <Button type="secondary" size="extra-extra-large" onClick={props.onCancel}>
              {t('common.cancel')}
            </Button>
          )}
          <Button htmlType="submit" danger size="extra-extra-large">
            {t(isFreelancer ? 'employee_delete.button.freelancer' : 'employee_delete.button.employee', {
              name: employee.name,
            })}
          </Button>
        </Col>
      </Row>
      {props.employees.saving && <LoadingOverlay />}
    </div>
  )
}

export default withValidations<Props, any, any>({
  mapPropsToFields: () => ({}),
  onSubmit: () => ({}),
})(DeleteEmployeeForm)
